import type { SyntaxNode } from 'web-tree-sitter';
import type { SymbolImportBinding } from '../../types.js';
import { extractEcmaScriptImportBindings } from './ecma-script-imports.js';
import { extractEcmaScriptReexportBindings } from './ecma-script-exports.js';

export { extractEcmaScriptImportBindings } from './ecma-script-imports.js';

/** Extract import and re-export bindings for ECMAScript modules. */
export function extractEcmaScriptBindings(
  root: SyntaxNode,
  filePath: string,
  workspaceFiles: ReadonlySet<string>,
): SymbolImportBinding[] {
  const imports = extractEcmaScriptImportBindings(root, filePath, workspaceFiles);
  const reexports = extractEcmaScriptReexportBindings(root, filePath, workspaceFiles);
  return [...imports, ...reexports];
}
